import React from "react";
import { Settings, LogOut, ChevronRight } from "lucide-react";

export default function ScoutProfile() {
  return (
    <div className="p-4 pb-6">
      <div className="flex items-center gap-4">
        <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#FFC107] to-[#E6AC00] flex items-center justify-center text-[#080B0D] font-black text-[18px]">AJ</div>
        <div>
          <div className="text-[16px] font-black">Alex Jordan</div>
          <div className="text-[12px] text-[#A1A1AA]">Scout · Joliet, IL</div>
        </div>
      </div>
      <div className="mt-6 sb-card divide-y divide-[#2A2F34]">
        {["Account", "Payouts", "Notifications", "Support", "Terms & Privacy"].map((r) => (
          <button key={r} className="w-full flex items-center justify-between p-4 text-[13px] hover:bg-white/5">
            <span>{r}</span>
            <ChevronRight size={14} className="text-[#A1A1AA]" />
          </button>
        ))}
      </div>
      <button className="mt-4 sb-btn-secondary w-full text-[12px]"><LogOut size={14} /> Sign Out</button>
      <div className="mt-4 text-center text-[10px] text-[#52525b]">v0.9.0 (prototype)</div>
    </div>
  );
}
